module.exports = __webpack_public_path__ + "img/ISO9001.17952e80.jpg";